export default "__VITE_ASSET__a1dd2405__"